export default __webpack_public_path__ + "static/media/capture.edfc6d42.svg";